import { render, staticRenderFns } from "./securityCenter.vue?vue&type=template&id=509c0cbe"
import script from "./securityCenter.vue?vue&type=script&lang=js"
export * from "./securityCenter.vue?vue&type=script&lang=js"
import style0 from "./securityCenter.vue?vue&type=style&index=0&id=509c0cbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports